// extracted by mini-css-extract-plugin
export var isShowingMobileMap = "search_app-module__isShowingMobileMap___Ku4jE";
export var trailErrorFallbackContainer = "search_app-module__trailErrorFallbackContainer___SBPwX";